import { render, staticRenderFns } from "./CbsRecordPage.vue?vue&type=template&id=c68ae4d0&scoped=true"
import script from "./CbsRecordPage.vue?vue&type=script&lang=js"
export * from "./CbsRecordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/maxgpark/dev/cubus/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68ae4d0",
  null
  
)

export default component.exports